
import {Toast} from "vant";
import {activity} from "../activity/getInfo";


let mixGetSchool = {
    data(){
        return {
            count: 0,

            loading: false,
            finished: true,

            searchName: '',
            start: 0,
            limit: 15,

            schools: [],

            isFirstTime: true
        }
    },
    created() {
        // console.log("========"+this.$options.name)
        // this.loading = true
        // this.getDetailLoad()
    },
    methods:{
        refresh(name){
            this.start = 0
            this.loading = false
            this.finished = false
            this.schools=[]
            this.searchName = name

            if(this.isFirstTime==true){
                this.isFirstTime = false
            }else{
                this.onLoad()
            }
        },
        onLoad(){
            setTimeout(() => {
                this.getDetailLoad()
            }, 300);
        },
        getDetailLoad(){
            activity.searchSchoolsName(
                this.searchName,
                this.start,
                this.limit
            ).then(res=>{
                console.log("length:"+res.schools.length)
                if(res.schools.length!=this.limit){
                    this.finished = true
                }else{
                    this.start += this.limit
                }
                // this.schools.clear()
                for (let index in res.schools){
                    this.schools.push(res.schools[index])
                }
            }).catch(()=>{
                console.log("catch==================================")
            }).finally(()=>{
                this.count++
                this.loading = false;
                console.log("finally======================"+this.count+"  name:",this.$options.name)
            })
        }
    }

}

export default mixGetSchool